import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const SignupMessage = styled.div`
  font-size: 1rem;
  font-weight: 900;
  color: #323232;
  text-align: center;
  margin-top: 2rem;
`;

const Aside = styled.div`
  margin-top: 10px;
  font-size: 0.8rem;
  font-weight: 400;
  color: #666;
`;

/**
 * "Sign up or log in" CTA for a signed-out visitor after unlock, before anyone
 * has claimed the day (the only time the backend still answers them with
 * `unauthorized`). The page keeps following the day, so the art shows up here
 * once someone claims it.
 */
export const AotdSignupCta: React.FC = () => (
  <SignupMessage>
    Today&apos;s art is up for grabs. Sign in to race for it!
    <br />
    <Link to="/login" style={{ marginRight: "10px" }}>
      Log In
    </Link>
    <Link to="/register">Sign Up</Link>
    <Aside>Or stay here: you&apos;ll see it painted as soon as someone claims it.</Aside>
  </SignupMessage>
);

export default AotdSignupCta;
